<template>
  <div>
    <transition
      appear
      appear-active-class="fade-enter-active"
      leave-active-class="fade-leave-active"
    >
      <div>
        <p>Le logo carré de votre Organisme.</p>

        <p>Il sera utilis&eacute; sur l'espace Uska de vos socio-professionnels.</p>

        <p>Les formats d&#39;images accept&eacute;s sont <strong>jpg</strong> ou <strong>png</strong>.</p>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "SquaredLogoField",
}
</script>
